import type { PostHog } from "posthog-js";

export const FAVORITE_ADD = "favorite_add";
export const FAVORITE_REMOVE = "favorite_remove";
export const FAVORITE_OPEN = "favorite_open";

export type FavoriteEvent =
  | typeof FAVORITE_ADD
  | typeof FAVORITE_REMOVE
  | typeof FAVORITE_OPEN;

export type FavoriteSurface =
  | "search_standard_list"
  | "search_standard_map"
  | "search_curated_list"
  | "search_curated_map"
  | "search_researcher_list"
  | "search_researcher_map"
  | "search_suggested"
  | "search_explore"
  | "search_favorites"
  | "search_recently_viewed"
  | "onboarding_need_hotel"
  | "explore_list"
  | "explore_map"
  | "similar_hotels"
  | "recent_hotels"
  | "hotel_details"
  | "favorites_history"
  | "favorites_page";

export function captureFavoriteEvent(
  posthog: Pick<PostHog, "capture"> | undefined,
  event: FavoriteEvent,
  propertyId: number,
  surface: FavoriteSurface
): void {
  if (!posthog) return;

  try {
    const result = posthog.capture(event, {
      property_id: propertyId,
      platform: "web",
      surface,
    });
    const maybePromise: unknown = result;
    if (
      maybePromise &&
      typeof (maybePromise as { then?: unknown }).then === "function"
    ) {
      void Promise.resolve(maybePromise).catch(() => undefined);
    }
  } catch {
    // Analytics must never alter favorite product state.
  }
}
